var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pauseIcon"},[_c('span',{staticClass:"clock"},[_c('icon',{attrs:{"id":"clock"}})],1),_c('span',{staticClass:"icon"},[_c('icon',{attrs:{"id":_vm.id}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }